import { axios } from '@/lib/axios';

export const deleteCurrency = (faq_id: string) => {
  const payload = {
    currency_id: faq_id,
  };
  return axios.post('/admin-api/delete-currency', payload);
};
